
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'da', // set locale
    fallbackLocale: 'en', // set fallback locale
    silentTranslationWarn: true, 
    messages: {'da': {'test': 'test1'}}, // set locale messages
});

export default i18n